import React from "react";
import "./PrincipalMessage.css";
import MessagePanel from "../../../theme/messagePanel/MessagePanel.js";
import { principal_message } from "../../../config/constants.js";
import { PrincipalImage } from "../../../assets/exports/FileExports.js";

const PrincipalMessage = () => {
  return (
    <div className="container principal-message-container">
      <MessagePanel imageUrl={PrincipalImage} {...principal_message} />
    </div>
  );
};

export default PrincipalMessage;
